import { useContext } from 'react';
import { HeaderTopContext } from './HeaderTopContextProvider';

export function useHeaderTopContext() {
    const context = useContext(HeaderTopContext);

    if (context === undefined) {
        throw new Error('React context provider missing: HeaderTopContextProvider');
    }

    return context;
}
